<div class="container my-5">
  <div class="text-center mb-5">
    <h1 class="fw-bold">Contact {{ title }}</h1>
    <p class="lead">Have a product question, want a walkthrough, or need account support? Talk to the YachtApp team.</p>
  </div>

  <div class="row g-4">
    <div class="col-md-7">
      <div class="card shadow rounded-4 border-0">
        <div class="card-body p-4">
          <h4 class="mb-3">Send Us a Message</h4>

          <div *ngIf="submissionSuccess" class="alert alert-success" role="status">
            Thanks for reaching out! We received your message and will get back to you shortly.
          </div>
          <div *ngIf="submissionError" class="alert alert-danger" role="alert">
            {{ submissionError }}
          </div>

          <form [formGroup]="contactForm" (ngSubmit)="submit()" novalidate>
            <div class="d-none" aria-hidden="true">
              <label for="website" class="form-label">Website</label>
              <input type="text" id="website" formControlName="website" autocomplete="off" tabindex="-1" />
            </div>
            <div class="mb-3">
              <label for="name" class="form-label">Your Name</label>
              <input type="text" class="form-control" id="name" formControlName="name" placeholder="Captain John Smith"
                [class.is-invalid]="controls.name.touched && controls.name.invalid" />
              <div class="invalid-feedback" *ngIf="controls.name.touched && controls.name.hasError('required')">
                Please enter your name so we know who to reach out to.
              </div>
              <div class="invalid-feedback" *ngIf="controls.name.touched && controls.name.hasError('maxlength')">
                Names must be 100 characters or fewer.
              </div>
            </div>

            <div class="mb-3">
              <label for="email" class="form-label">Email Address</label>
              <input type="email" class="form-control" id="email" formControlName="email" placeholder="you@boatmail.com"
                [class.is-invalid]="controls.email.touched && controls.email.invalid" />
              <div class="invalid-feedback" *ngIf="controls.email.touched && controls.email.hasError('required')">
                An email address is required so we can reply.
              </div>
              <div class="invalid-feedback" *ngIf="controls.email.touched && controls.email.hasError('email')">
                Please provide a valid email address.
              </div>
              <div class="invalid-feedback" *ngIf="controls.email.touched && controls.email.hasError('maxlength')">
                Email addresses must be 254 characters or fewer.
              </div>
            </div>

            <div class="mb-3">
              <label for="subject" class="form-label">Subject</label>
              <input type="text" class="form-control" id="subject" formControlName="subject"
                placeholder="Product walkthrough, fleet setup, account support..."
                [class.is-invalid]="controls.subject.touched && controls.subject.invalid" />
              <div class="invalid-feedback" *ngIf="controls.subject.touched && controls.subject.hasError('maxlength')">
                Subject lines must be 150 characters or fewer.
              </div>
            </div>

            <div class="mb-3">
              <label for="message" class="form-label">Message</label>
              <textarea class="form-control" id="message" rows="5" formControlName="message"
                placeholder="Describe your issue or request..."
                [class.is-invalid]="controls.message.touched && controls.message.invalid"></textarea>
              <div class="invalid-feedback" *ngIf="controls.message.touched && controls.message.hasError('required')">
                Please provide a brief description of how we can help.
              </div>
              <div class="invalid-feedback" *ngIf="controls.message.touched && controls.message.hasError('maxlength')">
                Messages must be 2000 characters or fewer.
              </div>
            </div>

            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="gdprConsent" formControlName="gdprConsent"
                [class.is-invalid]="controls.gdprConsent.touched && controls.gdprConsent.invalid" />
              <label class="form-check-label" for="gdprConsent">
                I consent to YachtApp processing my contact request data according to the
                <a routerLink="/privacy-policy">Privacy Policy</a> and <a routerLink="/terms-and-conditions">Terms and Conditions</a>.
              </label>
              <div class="invalid-feedback d-block"
                *ngIf="controls.gdprConsent.touched && controls.gdprConsent.hasError('requiredTrue')">
                You must provide consent before submitting this form.
              </div>
            </div>

            <button type="submit" class="btn btn-primary px-4" [disabled]="isSubmitting || contactForm.invalid">
              <span *ngIf="!isSubmitting">Send</span>
              <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              <span class="visually-hidden" *ngIf="isSubmitting">Sending...</span>
            </button>
          </form>
        </div>
      </div>
    </div>

    <div class="col-md-5">
      <div class="card shadow rounded-4 border-0 bg-light">
        <div class="card-body p-4">
          <h4 class="mb-3">Get In Touch</h4>
          <p><i class="bi bi-geo-alt-fill text-primary me-2"></i><span class="d-inline-block align-top">{{ contactData.companyName }}<br>{{ contactData.address }}</span></p>
          <p><i class="bi bi-envelope-fill text-primary me-2"></i>{{ contactData.email }}</p>
          <p><i class="bi bi-telephone-fill text-primary me-2"></i>{{ contactData.phone }}</p>
          <hr />
          <h5 class="mb-2">{{ contactData.businessHours.title }}</h5>
          <p class="mb-0">{{ contactData.businessHours.weekdays }}</p>
          <p>{{ contactData.businessHours.weekend }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
